import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { DataGrid, GridOverlay } from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import Modal from 'react-modal';
import { getCommentListByTag } from '../services/asset.service';
import * as CryptoJS from "crypto-js";

function getFormatedDate(dateString) {
    if (dateString != null) {
        let dte = new Date(dateString);
        let year = dte.getFullYear();
        let month = dte.getMonth() + 1;
        let day = dte.getDate();
        if (month < 10) month = '0' + month;
        if (day < 10) day = '0' + day;
        return `${year}-${month}-${day}`;
    } else {
        return '-';
    }
}

const customModalStyles = {
    overlay: {
        backgroundColor: 'rgba(15, 23, 42, 0.65)',
        backdropFilter: 'blur(4px)',
        zIndex: 1300,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px'
    },
    content: {
        position: 'relative',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        width: '100%',
        maxWidth: '920px',
        maxHeight: '85vh',
        background: '#ffffff',
        borderRadius: '16px',
        border: '1px solid rgba(226, 232, 240, 0.8)',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 15px rgba(0, 0, 0, 0.05)',
        padding: 0,
        overflow: 'hidden',
        outline: 'none',
        display: 'flex',
        flexDirection: 'column'
    }
};

const CommentListPopupBox = ({ tag, isOpen, onClose }) => {
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);

    const encryptTag = tag ? CryptoJS.AES.encrypt(JSON.stringify({
        'tag': tag, 'back_url': 'view-comments'
    }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString() : '';

    const columns = [
        {
            field: "tag", editable: false, hide: false, headerName: "TAG", width: 180,
            renderCell: (params) => {
                let EncryptID = CryptoJS.AES.encrypt(JSON.stringify({
                    'tag': params.row.tag, 'back_url': 'view-comments'
                }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
                return (
                    <a className="al-cell-tag-link" href={`/asset-basic-details?tag=${EncryptID}`} style={{ textDecoration: 'none', color: '#0e8aca', fontWeight: 600 }}>
                        <i className="bi bi-tag-fill me-1" style={{ fontSize: '0.85rem' }} />
                        {params.value}
                    </a>
                );
            }
        },
        {
            field: "comment",
            editable: false,
            headerName: "Comment Description",
            flex: 1,
            minWidth: 260,
            renderCell: (params) => (
                <div style={{ whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: '1.4', padding: '6px 0' }}>
                    {params.value || '-'}
                </div>
            )
        },
        {
            field: "created_by_name",
            editable: false,
            headerName: "Comment Added By",
            width: 180,
            renderCell: (params) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <i className="bi bi-person-circle text-secondary" style={{ fontSize: '1.05rem', color: '#64748b' }} />
                    <span style={{ fontWeight: 500, color: '#334155' }}>{params.value || 'System'}</span>
                </div>
            )
        },
        {
            field: "created_date",
            editable: false,
            headerName: "Date of Addition",
            width: 140,
            renderCell: (params) => (
                <span style={{
                    backgroundColor: '#f1f5f9',
                    color: '#475569',
                    padding: '3px 10px',
                    borderRadius: '12px',
                    fontSize: '0.78rem',
                    fontWeight: 600,
                    border: '1px solid #e2e8f0'
                }}>
                    <i className="bi bi-calendar3 me-1" style={{ fontSize: '0.72rem' }} />
                    {getFormatedDate(params.row.created_date)}
                </span>
            )
        },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 90,
            sortable: false,
            renderCell: (params) => {
                let EncryptID = CryptoJS.AES.encrypt(JSON.stringify({
                    'commentid': params.row.id,
                }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
                return (
                    <a
                        href={`/add-comments/?comment_ID=${EncryptID}`}
                        className="btn btn-sm btn-outline-primary"
                        style={{
                            borderRadius: '6px',
                            padding: '3px 9px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderColor: '#cbd5e1',
                            color: '#0e8aca'
                        }}
                        title="Edit Comment"
                    >
                        <i className="bi bi-pencil-fill" style={{ fontSize: '0.8rem' }} />
                    </a>
                );
            }
        },
    ];

    useEffect(() => {
        const getTransferInfo = async function (decryptedTAG) {
            setLoading(true);
            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': { 'tag': decryptedTAG },
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData1 = { 'token': EncryptData };
            try {
                const res = await getCommentListByTag(oData1);
                if (res?.data?.data?.length) {
                    setItems(res.data.data);
                } else {
                    setItems([]);
                }
            } catch (error) {
                console.error("Error fetching transfer info:", error);
                setItems([]);
            } finally {
                setLoading(false);
            }
        }
        if (tag) {
            getTransferInfo(tag);
        }
    }, [tag]);

    const CustomLoader = () => (
        <GridOverlay>
            <CircularProgress color="primary" size={32} />
        </GridOverlay>
    );

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="TAG Comment List"
            style={customModalStyles}
            ariaHideApp={false}
        >
            {/* Modal Header */}
            <div style={{
                background: 'linear-gradient(135deg, #0e8aca 0%, #066999 100%)',
                color: '#ffffff',
                padding: '16px 24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <div style={{
                        width: '36px',
                        height: '36px',
                        borderRadius: '10px',
                        background: 'rgba(255, 255, 255, 0.18)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backdropFilter: 'blur(4px)'
                    }}>
                        <i className="bi bi-chat-square-quote-fill" style={{ fontSize: '1.15rem' }} />
                    </div>
                    <div>
                        <h5 style={{ margin: 0, fontSize: '1.1rem', fontWeight: '700', letterSpacing: '0.3px', color: '#ffffff' }}>
                            TAG Comment List
                        </h5>
                        <div style={{ fontSize: '0.78rem', color: 'rgba(255, 255, 255, 0.85)', marginTop: '2px' }}>
                            Asset Tag: <span style={{
                                background: 'rgba(255,255,255,0.22)',
                                padding: '2px 8px',
                                borderRadius: '12px',
                                fontWeight: '600',
                                color: '#fff',
                                marginLeft: '4px'
                            }}>{tag}</span>
                        </div>
                    </div>
                </div>

                <button
                    type="button"
                    onClick={onClose}
                    style={{
                        background: 'rgba(255, 255, 255, 0.15)',
                        border: 'none',
                        color: '#ffffff',
                        width: '32px',
                        height: '32px',
                        borderRadius: '50%',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'all 0.2s ease',
                        outline: 'none'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.3)'}
                    onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)'}
                    title="Close"
                >
                    <i className="bi bi-x-lg" style={{ fontSize: '0.9rem' }} />
                </button>
            </div>

            {/* Modal Sub-Header Bar */}
            <div style={{
                padding: '12px 24px',
                background: '#f8fafc',
                borderBottom: '1px solid #e2e8f0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '0.85rem', color: '#475569', fontWeight: '600' }}>
                    <i className="bi bi-card-text text-primary" style={{ fontSize: '1rem', color: '#0e8aca' }} />
                    <span>Total Comments:</span>
                    <span style={{
                        background: '#e0f2fe',
                        color: '#0369a1',
                        padding: '2px 10px',
                        borderRadius: '12px',
                        fontWeight: '700',
                        fontSize: '0.82rem'
                    }}>{items.length}</span>
                </div>

                {tag && (
                    <a
                        href={`/add-comments/?tag=${encryptTag}`}
                        className="btn btn-sm btn-primary"
                        style={{
                            borderRadius: '8px',
                            padding: '6px 14px',
                            fontWeight: '600',
                            fontSize: '0.82rem',
                            backgroundColor: '#0e8aca',
                            borderColor: '#0e8aca',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '5px',
                            boxShadow: '0 2px 5px rgba(14, 138, 202, 0.25)'
                        }}
                    >
                        <i className="bi bi-plus-lg" style={{ fontSize: '0.85rem' }} /> Add Comment
                    </a>
                )}
            </div>

            {/* Modal Body / Table Content */}
            <div style={{ padding: '16px 24px', flex: 1, overflowY: 'auto' }}>
                <Box sx={{ width: '100%', minHeight: 280 }}>
                    <DataGrid
                        rows={items}
                        getRowId={(row) => row.id}
                        columns={columns}
                        pageSize={10}
                        rowsPerPageOptions={[10, 20, 50]}
                        autoHeight
                        rowHeight={52}
                        components={{
                            LoadingOverlay: CustomLoader,
                        }}
                        loading={loading}
                        disableSelectionOnClick
                        sx={{
                            border: '1px solid #e2e8f0',
                            borderRadius: '10px',
                            overflow: 'hidden',
                            fontFamily: 'inherit',
                            '& .MuiDataGrid-columnHeaders': {
                                backgroundColor: '#f1f5f9',
                                borderBottom: '1px solid #cbd5e1',
                                fontSize: '0.78rem',
                                fontWeight: 700,
                                textTransform: 'uppercase',
                                color: '#1e293b',
                                letterSpacing: '0.5px'
                            },
                            '& .MuiDataGrid-columnHeaderTitle': {
                                fontWeight: 700,
                                color: '#1e293b'
                            },
                            '& .MuiDataGrid-row': {
                                fontSize: '0.83rem',
                                borderBottom: '1px solid #f1f5f9',
                                '&:hover': {
                                    backgroundColor: '#f8fafc'
                                }
                            },
                            '& .MuiDataGrid-cell': {
                                borderBottom: '1px solid #f1f5f9',
                                display: 'flex',
                                alignItems: 'center'
                            },
                            '& .MuiDataGrid-footerContainer': {
                                borderTop: '1px solid #e2e8f0',
                                backgroundColor: '#f8fafc'
                            }
                        }}
                    />
                </Box>
            </div>
        </Modal>
    );
};

export default CommentListPopupBox;